const abteilungen = {
    "Geschäftsstelle / Vorstand": "Geschäftsstelle / Vorstand",
    "Badminton": "Badminton",
    "Basketball": "Basketball",
    "Fußball": "Fußball",
    "Gesundheitssport": "Gesundheitssport",
    "Erlebnissport": "Erlebnissport",
    "OGS": "Offene Ganztagsschule",
};

const kurs_absagen = {
    "aqua": "Orthpädie-Aqua",
    "herzsport": "Herzsport (Kardiologie)",
};
const geschlecht = {
    "m": "männlich",
    "w": "weiblich",
    "d": "divers",
};

const sportangebote = {
    "Badminton": "Badminton",
    "Basketball": "Basketball",
    "Fußball/Talentwerk": "Fußball/Talentwerk",
    "Gesundheitssport": "Gesundheitssport",
    "Sport und Natur": "Sport und Natur",
    "Turnen und Tanz": "Turnen und Tanz",
    "Fitness und Entspannung": "Fitness und Entspannung",
    "Eltern-Kind-Turnen": "Eltern-Kind-Turnen",
}

const month = {
    "Januar": "Januar",
    "Februar": "Februar",
    "März": "März",
    "April": "April",
    "Mai": "Mai",
    "Juni": "Juni",
    "Juli": "Juli",
    "August": "August",
    "September": "September",
    "Oktober": "Oktober",
    "November": "November",
    "Dezember": "Dezember"
}
const foerdervereinBeitrag = {
    "single": "Einzelmitgliedschaft (36€ / Jahr)",
    "family": "Familienmitgliedschaft (60€ / Jahr)",
    "once-yearly": "Regelmäßige jährliche Spende"

}
const beitrag = {
    "adult": {
        label: "Erwachsene",
        priceMonth: "15,50€/Monat",
        priceYear: "(186,00€/Jahr)"
    },
    "child": {
        label: "Unter 18-Jährige",
        priceMonth: "11,67€/Monat",
        priceYear: "(140,00€/Jahr)"
    },
    "family": {
        label: "Familien",
        priceMonth: "29,00€/Monat",
        priceYear: "(348,00€/Jahr)"
    },
    "inactive": {
        label: "Inaktive",
        priceMonth: "5,50€/Monat",
        priceYear: "(66,00€/Jahr)"
    },
    "free": {
        label: "Eltern-Kind-Turnen",
        priceMonth: "Beitragsfrei"
    }
};
const addBeitrag = {
    "talentwerk": {
        label: "Talentwerk",
        priceMonth: "25,00€/Monat",
        priceYear: "(300,00€/Jahr)"
    },
    "none": {
        label: "Keinen",
        priceMonth: "",
        priceYear: ""
    }
}

const beteiligung = {
    training: "Trainings- u. Übungsleiterbereich",
    orga: "organisatorisch-verwaltender Bereich (Vereinsorganisation, Planung und Durchführung von Vereins- u. Sportfesten etc.)"
}

const accept = {
    ja: "Ja",
    nein: "Nein"
}
const evaluation = {
    freunde: "Freunde",
    presse: "Presse",
    social: "Social Media / Internet",
    other: "Anderes"
}

const flexkarte = {
    s: { title: "Flexkarte S", price: "50€", description: "(10 Einheiten à 1 Stunde)" },
    m: { title: "Flexkarte M", price: "100€", description: "(10 Einheiten à 1 Stunde)" },
    l: { title: "Flexkarte L", price: "150€", description: "(10 Einheiten à 1,5 - 2 Stunden)" },
}
const program = {
    bootcamp: "Bootcamp",
    gymwalk: "Gymwalk",
    nordicWalking: "NordicWalking",
    pilates: "Pilates",
    standard: "Standard-Tanzkurs",
    breakdance: "Breakdance",
    wandern: "Wandern",
    radfahren: "Radfahren",
    zumba: "Zumba",
    beachvolleyball: "Beachvolleyball",
    streuobst: "Streuobstwiesen-Yoga",
    estaticDance: "EstaticDance"
}

const shirt = {
    116: "116",
    128: "128",
    140: "140",
    152: "152",
    164: "164",
    S: "S",
    M: "M",
    L: "L"
}
export { foerdervereinBeitrag, shirt, program, flexkarte, evaluation, abteilungen, kurs_absagen, geschlecht, sportangebote, accept, addBeitrag, beitrag, month, beteiligung };